var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('nav',{staticClass:"lang"},[_c('ul',{staticClass:"lang__list"},_vm._l((_vm.languages),function(url,lang){return _c('li',{key:lang,staticClass:"lang__item",class:{
        active: _vm.currentLang === lang,
      }},[_c('router-link',{attrs:{"to":url}},[_vm._v(_vm._s(lang))])],1)}),0)])}
var staticRenderFns = []

export { render, staticRenderFns }